import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Grid } from '@mui/material';
import MoreDetails from 'components/moreDetails/MoreDetails';
import FilterSubVendor from '../FilterSubVendor';
import { subVendorVechileMatrix } from './SubVendorVechileData';
import MatrixDriverVendor from 'pages/vendor/driverVendor/MatrixDriverVendor';
import VehicleInfo from 'pages/vendor/driverVendor/VehicleInfo';


function SubVendorVechileTab(props) {
  // const [value, setValue] = useState('1');

  const handleChange = (event, newValue) => {
    props?.onTabChange(newValue)
  };


  return (
    <Grid container>
      <Grid item className="tableContainer" xs={12}>
        <Box className="contentBoxStyle">
          <TabContext value={props?.value}>
            <Grid
              container
              className="tabBoxStyle"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item >
                <TabList
                  className='minHeight32'
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                  TabIndicatorProps={{
                    style: { backgroundColor: 'white' }, // Replace 'none' with your desired color
                  }}
                >
                  <Tab label="Matrix" value="1" className="tabStyle" />
                  <Tab label="More Details" value="2" className="tabStyle" />
                  <Tab label="Vehicle Info" value="3" className="tabStyle" />
                </TabList>
              </Grid>

              <Grid item >
              {/* {value !== 'More Details' && <FilterSubVendor />} */}
              </Grid>
            </Grid>
            <TabPanel
              value="1"
              sx={{ width: '100%' }}
              className="tabPanelStyle"
            >
              <MatrixDriverVendor  matrix={subVendorVechileMatrix(props?.vehicleMatrixData)}/>
            </TabPanel>
            <TabPanel value="2" className="tabPanelStyle">
              <MoreDetails details={props?.vehicleMoreData}/>
            </TabPanel>
            <TabPanel value="3">
              <VehicleInfo vehicleInfo={props?.vehicleInfo} vehicleImage={props?.vehicleImage} amenitiesVehicle={props?.amenitiesVehicle} editButton={props?.editButton}/>
            </TabPanel>
          </TabContext>
        </Box>
      </Grid>
    </Grid>
  );
}

export default SubVendorVechileTab;
